import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { CheckCircle2 } from "lucide-react";

const BENEFITS = [
  "Reach language and math students actively searching for 1-on-1 help",
  "Set your own hourly rate, availability and subject mix",
  "Get email alerts the moment a student requests a session",
  "Keep 100% ownership of your student relationships",
];

export default function BecomeTutor() {
  return (
    <div className="bg-grain">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-primary">For tutors</p>
          <h1 className="mt-3 text-4xl lg:text-5xl font-heading font-bold tracking-tight leading-[1.1]">
            Grow your tutoring practice on Tutors Paradise.
          </h1>
          <p className="mt-5 text-lg text-muted-foreground max-w-xl">
            List your French, English, Spanish or Math expertise. We send you qualified students
            — you keep every student connection.
          </p>
          <div className="mt-7 flex gap-3">
            <Button asChild size="lg" className="rounded-full h-12 px-7">
              <Link to="/register">Create tutor profile</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="rounded-full h-12 px-7">
              <Link to="/login">I already have an account</Link>
            </Button>
          </div>
        </div>

        <Card className="p-8">
          <h3 className="font-heading text-xl font-semibold">What you get</h3>
          <ul className="mt-5 space-y-3">
            {BENEFITS.map((b) => (
              <li key={b} className="flex gap-3">
                <CheckCircle2 className="h-5 w-5 text-emerald-500 shrink-0 mt-0.5" />
                <span className="text-muted-foreground">{b}</span>
              </li>
            ))}
          </ul>
        </Card>
      </section>
    </div>
  );
}
